<template>
  <div class="modal d-flex-column fadeIn">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    heading: String,
  },
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: scroll;


  @media only screen and (min-width: $sm)  {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,.75);
  }
}
</style>
